import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import PropTypes from "prop-types";
import Loader from "components/Loader";
function ProtectedRoute({ children }) {
  const [auth, setAuth] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      setAuth(false);
      return;
    }

    axios
      .get(`${API_BASE_URL}/api/auth/check-auth`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      })
      .then((res) => {
        setAuth(res.data.success);
      })
      .catch(() => {
        setAuth(false);
      });
  }, []);

  if (auth === null) {
    return <Loader />;
  }

  if (!auth) {
    return <Navigate to="/authentication/sign-in" replace />;
  }
  return children; // Render children if authenticated
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
